import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { AboutLaura } from '../components/AboutLaura';
import { Testimonials } from '../components/Testimonials';
import { FinalCTA } from '../components/FinalCTA';
export function SobreLauraPage() {
  return <>
      <PageHeader eyebrow="Quién está detrás de este trabajo" title="Laura" subtitle="Hay cosas que no se aprenden. Se atraviesan." data-id="element-567" />
      <AboutLaura data-id="element-568" />
      <Testimonials data-id="element-569" />
      <FinalCTA data-id="element-570" />
    </>;
}